<div mat-dialog-title>

  <h1 class="titulo-simpli">Registra o actualiza tu clave</h1>
  <small class="subtitulo-simpli">Para sincronizar tus datos, ingresa la clave que utilizas en el SII</small>


  <div class="btn_cerrar" mat-dialog-close>

    <span class="material-symbols-outlined">close</span>

  </div>


</div>


<div mat-dialog-content>
  <div  class="col-lg-12 col-md-12 col-sm-12 col-xs-12 col-top">
    <mat-card class="animate__animated animate__fadeIn" style="border: none;box-shadow: none !important;">

      <mat-card-content>

        <form>
          <mat-form-field appearance="fill">
            <mat-label>Empresa</mat-label>
            <input matInput type="text" readonly value="{{business_name}}">
            <span (click)="cambiarEmpresa()" matTooltip="Cambiar empresa" class="material-icons animate__animated animate__fadeIn" matSuffix style="color:rgb(153, 153, 153);margin-right: 10px;cursor: pointer;">edit_square</span>
            <mat-hint>RUT: {{rut_company}}</mat-hint>
          </mat-form-field>


        </form>


        <form  [formGroup]="valForm">

          <div class="row">


            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 col-top">

              <mat-form-field appearance="fill">
                <mat-label>Clave SII</mat-label>
                <input #passwordInput1 formControlName="clave_sii" matInput type="password" required (keyup)="validate_key($event)">
                @if (saving_sii) {
                  <mat-spinner color="primary" diameter="20" matSuffix></mat-spinner>
                }
                @if (success_sii) {
                  <span class="material-icons animate__animated animate__fadeIn" matSuffix style="color:#3BA46F;">check_circle</span>
                }
                <mat-hint>
                  @if (fase == 'validando') { Validando con el SII… }
                  @else if (fase == 'guardando') { Guardando… }
                  @else { Ingresa tu clave SII }
                </mat-hint>
                @if (valForm.controls['clave_sii'].hasError('incorrect')) {
                  <mat-error>
                    La clave no es correcta.
                  </mat-error>
                }
                @if (valForm.controls['clave_sii'].hasError('required')) {
                  <mat-error>
                    Clave SII requerida.
                  </mat-error>
                }
              </mat-form-field>


              @if (aviso && !fase) {
                <div class="clave-aviso" [ngClass]="aviso.clase" role="status">
                  <span class="material-symbols-outlined">{{ aviso.icono }}</span>
                  <div class="clave-aviso__texto">
                    <span class="clave-aviso__titulo">{{ aviso.titulo }}</span>
                    <span class="clave-aviso__detalle">{{ aviso.detalle }}</span>
                  </div>
                </div>
              }

              <div class="leyenda">

                Su clave está protegida con altos estándares de seguridad y encriptación. Al continuar, confirma que acepta nuestra
                <a class="simpli-color2 cursor-pointer text-none" href="https://simplilatam.com/politica-de-privacidad/" target="_blank">política de privacidad</a>
                diseñada para resguardar su información en todo momento.

              </div>

            </div>


          </div>



        </form>
      </mat-card-content>
    </mat-card>

    <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">

        <div [ngClass]="{'disable-btn':disable_btn == true, 'btn-simpli-container':true}">

          @if (success_sii == false) {
            <button [disabled]="disable_btn || bloqueado" mat-flat-button class="primary-button" type="button" style="margin-top: 10px;" (click)="verificar_guardar_clave_sii(true)">
              @if (!spinner_btn) {
                <mat-label>Guardar</mat-label>
              }
              @if (spinner_btn) {
                <span><span class="material-symbols-outlined mat-spin">progress_activity</span></span>
              }
            </button>
          }

          @if (success_sii == true) {
            <button  [disabled]="disable_btn" mat-flat-button class="primary-button"  (click)="verificar_guardar_clave_sii()">
              @if (!spinner_btn) {
                <mat-label>Guardar</mat-label>
              }
              @if (spinner_btn) {
                <span><span class="material-symbols-outlined mat-spin">progress_activity</span></span>
              }
            </button>
          }

        </div>

      </div>
    </div>
  </div>
</div>